import React from "react";
import { Statistic } from '../../PSY/Statistic'
import { BORROW_FEE, LIQUIDATION_RESERVE, TOTAL_DEBT } from '../../../lexicon'
import { Decimal } from '@liquity/lib-base'

type Props = {
  reserveFee: Decimal
  borrowingFee: Decimal
  borrowingRate: string
  totalDebt: Decimal
}

export const Quotation: React.FC<Props> = ({ reserveFee, borrowingFee, borrowingRate, totalDebt} ) => {
  return (
    <div className="bg-component border-component p-5 flex flex-col justify-between">
      <div className="text-style-heading">Quotation</div>
      <div className="flex flex-col mt-6">
        <Statistic lexicon={LIQUIDATION_RESERVE(reserveFee.prettify(2))} >
          {reserveFee.prettify(2)} SLSD
        </Statistic>
        <Statistic lexicon={BORROW_FEE} extra={borrowingRate}>
          {borrowingFee.prettify(2)} SLSD
        </Statistic>
        <Statistic lexicon={TOTAL_DEBT} border={false} >
          {totalDebt.prettify(2)} SLSD
        </Statistic>
      </div>
    </div>
  );
};
